import type { TicketDetailView } from '@mopla/ticketshop-api';

import { mapMyTicketDto } from '../../ticketshop/hooks/mapMyTicketDto';
import { IMyTicket } from '../../ticketshop/types';

/**
 * Map the single-ticket `TicketDetailView` DTO to the internal app model.
 * Reuses `mapMyTicketDto` for the fields shared with the list model and adds
 * the detail-only fields: `passengerName`, `ticketCode`, `secretWord`, `stops`,
 * `vatPercent`, `eligibilityForChipcard`, and the operator visuals delivered by
 * the BE (`operatorIconUrl` / `operatorWordmarkUrl`).
 */
export const mapTicketDetailDto = (dto: TicketDetailView): IMyTicket => ({
	...mapMyTicketDto(dto),
	passengerName: dto.passengerName,
	ticketCode: dto.ticketCode,
	secretWord: dto.secretWord,
	stops: dto.stops,
	vatPercent: dto.vatPercent,
	// BE-authoritative chipcard eligibility (detail endpoint only).
	eligibilityForChipcard: dto.eligibilityForChipcard,
	// Operator visuals come straight from the BE response.
	operatorIconUrl: dto.operatorIconUrl,
	operatorWordmarkUrl: dto.operatorWordmarkUrl,
	operatorFaqUrl: dto.operatorFaqUrl,
});
